import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { ActivatedRoute, Router } from '@angular/router'
import { BeatsSortBy } from '../../../enums/enums'
import { I18nService, LgType } from '../../../services/prod/i18n.service'
import { ProducerService } from '../../../services/producer.service'
import { AppType } from '../../../types/app.type'
import { ProducerType } from '../../../types/producer.type'

@Component({
  selector: 'bmcore-beatmaker-catalog-page',
  templateUrl: './bmcore-beatmaker-catalog-page.component.html',
  styleUrls: ['./bmcore-beatmaker-catalog-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreBeatmakerCatalogPageComponent implements OnInit {
  constructor(
    private activatedRoute: ActivatedRoute,
    private i18nService: I18nService,
    private producerService: ProducerService,
    private titleService: Title,
    private router: Router
  ) {}

  @Input() appType: AppType

  @Input() showVerificationIcon = false

  beatmakerIdOrUrl: number | string
  beatmakerId: number
  lg: LgType

  protected readonly BeatsSortBy = BeatsSortBy

  ngOnInit(): void {
    this.lg = this.i18nService.getLanguageForPage()
    this.beatmakerIdOrUrl = this.activatedRoute.snapshot.paramMap.get('beatmakerIdOrURL')
    this.getBeatmakerInfo()
  }

  getBeatmakerInfo() {
    this.producerService.getInformation(this.beatmakerIdOrUrl).subscribe(
      (res: ProducerType) => {
        this.beatmakerId = res.beatmakerId
        this.setTitle(res.beatmakerName)
      },
      () => {
        this.router.navigate(['/404'])
      }
    )
  }

  setTitle(beatmakerName: string) {
    this.titleService.setTitle(this.lg.documentTitles.setBeatmakerCatalogPageTitle(beatmakerName))
  }
}
